module.exports = __webpack_public_path__ + "img/Head.28b34420.jpg";